import { render, staticRenderFns } from "./city_word_edit.vue?vue&type=template&id=afe32798&scoped=true&"
import script from "./city_word_edit.vue?vue&type=script&lang=js&"
export * from "./city_word_edit.vue?vue&type=script&lang=js&"
import style0 from "./city_word_edit.vue?vue&type=style&index=0&id=afe32798&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe32798",
  null
  
)

export default component.exports